import { useUserInfoStore } from "app/Auth/useUserInfoStore";

/**
 * Optional way to retrieve userInfo instead of useUserInfo. Useful if you are not inside a ReactContext
 */
export const getUserInfo = () => {
  // Dont check store if it is ran in a test
  if (process.env.NODE_ENV === "test") {
    return null;
  }
  return useUserInfoStore.getState().userInfo;
};
